// ============================================================
// SINGSPACE ADMIN - LOADING SPINNER COMPONENT
// Composant de chargement réutilisable avec logo SING
// ============================================================

interface LoadingSpinnerProps {
  message?: string;
  submessage?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function LoadingSpinner({
  message = 'Chargement en cours',
  submessage = 'Veuillez patienter...',
  size = 'md',
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-12 h-12',
    md: 'w-16 h-16',
    lg: 'w-24 h-24',
  };

  const logoSizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4">
      <div className="relative">
        {/* Spinner rotatif */}
        <div
          className={`${sizeClasses[size]} border-4 border-slate-200 border-t-[#00758d] rounded-full animate-spin`}
        ></div>

        {/* Logo SING au centre */}
        <div className="absolute inset-0 flex items-center justify-center">
          <img src="/logo-seul.png" alt="SING" className={`${logoSizeClasses[size]} object-contain`} />
        </div>
      </div>

      <div className="text-center">
        <p className="text-slate-700 font-medium mb-1">{message}</p>
        <p className="text-sm text-slate-500">{submessage}</p>
      </div>
    </div>
  );
}
